import CompanyUser from "../../../../../../../core/model2/company-user-new/company-user"
import User from "../../../../../../../core/model2/user/user"
import ProjectUserSession from "../../../../../../../core/model2/project-user/project-user-session"

export default function quickAdd_getUsersIds(projectsIds: ID[]) {
    let users: User[] = []
    if (projectsIds.length === 0) {
        users = gd.session.companyUsers.filterByCompanyAndRoles(gd.companyId)
            .map((companyUser: CompanyUser) => {
                return companyUser.user
            })
    } else {
        gd.session.projectUsers.filterByProjects(projectsIds)
            .map((projectUser: ProjectUserSession) => {
                if (!projectUser.isTeam) {
                    users.push(projectUser.user)
                }
            })
    }

    return _(users)
        .uniqBy((user: User) => {
            return user.id
        })
        .sortBy((user: User) => {
            return user.name
        })
        .map((user: User) => {
            return user.id
        })
        .value()
}